import "./App.css";
import { Suspense, lazy } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ThemeProvider from "./utils/theme";
import LayoutWrapper from "./components/layout/LayoutWrapper";

// Lazy load pages
const Dashboard = lazy(() => import("./pages/Dashboard"));
const PrintRequests = lazy(() => import("./pages/PrintRequests"));
const Services = lazy(() => import("./pages/Services"));
const Configurations = lazy(() => import("./pages/Configurations"));
const Login = lazy(() => import("./pages/Login"));

// Initialize React Query client
const queryClient = new QueryClient();

// Define routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutWrapper />,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "/requests", element: <PrintRequests /> },
      { path: "/services", element: <Services /> },
      { path: "/configuration", element: <Configurations /> },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        
          <RouterProvider router={router} />
        
        <ToastContainer />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
